import { AdminInquiries } from "../../components/admin/AdminInquiries";
import { AdminRouteGuard } from "../../components/admin/AdminRouteGuard";

export default function AdminInquiriesPage() {
  return (
    <AdminRouteGuard requiredRole="admin">
      <div className="container py-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">
              Contact Inquiries
            </h1>
            <p className="text-muted-foreground">
              View all contact inquiries from users.
            </p>
          </div>
        </div>

        <AdminInquiries />
      </div>
    </AdminRouteGuard>
  );
}
